<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">体验卡管理</div>

      <div class="search-wrapper">
         <el-form :inline="true" v-model="paramData">
            <el-form-item label="状态">
               <el-select placeholder="请选择状态" v-model="paramData.status">
                  <el-option label="全部" :value="0"></el-option>
                  <el-option label="已发布" value="1"></el-option>
                  <el-option label="未发布" value="2"></el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <el-button class="margin-left-10" type="primary" @click="queryList">搜索</el-button>
         <el-button @click="clickReset">重置</el-button>
      </div>

      <div class="action-wrapper">
         <el-button type="primary" @click="clickAddition">新增</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="listData">
            <el-table-column align="center" label="ID" prop="id"></el-table-column>
            <el-table-column align="center" label="名称" prop="name"></el-table-column>
            <el-table-column align="center" label="特权角色" prop="privilegeRoleName"></el-table-column>
            <el-table-column align="center" label="体验时长" prop="duration"></el-table-column>
            <el-table-column align="center" label="有效期至">
               <template scope="{ row }">{{ handleValidDate(row) }}</template>
            </el-table-column>
            <el-table-column align="center" label="总张数">
               <template scope="{ row }">{{ row.quantity == -1 ? '无限' : row.quantity }}</template>
            </el-table-column>
            <el-table-column align="center" label="库存张数">
               <template scope="{ row }">{{ row.quantity == -1 ? '无限' : row.residualQuantity }}</template>
            </el-table-column>
            <el-table-column align="center" label="发放张数" prop="usedNum"></el-table-column>
            <el-table-column align="center" label="状态">
               <template scope="{ row }">{{ row.status == 1 ? '已发布' : '已撤销' }}</template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="180" fixed="right">
               <template scope="{ row }">
                  <div v-if="row.status == 2">
                     <el-button type="text" @click="clickPublish(row)">发布</el-button>
                     <el-button v-show="row.usedNum == 0" type="text" @click="clickEdit(row)">编辑</el-button>
                     <el-button type="text" style="color: red" @click="clickDelete(row)">删除</el-button>
                  </div>
                  <div v-else>
                     <el-button type="text" style="color: red" @click="clickRevoke(row)">撤销发布</el-button>
                  </div>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination-wrapper">
         <el-pagination v-show="total > 0" layout="total, prev, pager, next, jumper" :current-page="paramData.pageNum"
            :page-size='paramData.pageSize' :total="total" @current-change="changeCurrentPage">
         </el-pagination>
      </div>

   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         paramData: {
            status: 0, // 状态（0-全部 1-已发布 2-撤销发布）
            pageNum: 1,
            pageSize: 10,
         },
         total: 0,
         listData: [],
      }
   },

   mounted() {
      this.queryList();
   },

   methods: {
      // 查询列表
      queryList() {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/experienceCard/list',
            method: 'GET',
            params: { ...this.paramData }
         }).then((res) => {
            this.total = res.data.data.total || 0;
            this.listData = res.data.data.modelList || [];
         }).catch((err) => {
            this.total = 0;
            this.listData = [];
         }).finally(() => {
            this.loading = false;
         })
      },
      // 更新状态（发布或撤销）
      updateStatus(params) {
         let message = '确定要发布吗？发布后该篇会变成“已发布”状态，且用户端将会看到该篇内容';
         let title = '发布';
         if (params.status === 2) {
            message = '确定要撤销发布吗？撤销发布后该篇会变成“已撤销”状态，且用户端将无法看到该篇内容';
            title = '撤销';
         }
         this.$confirm(message, title, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.loading = true;
            this.$http({
               url: this.$util.domain + "/adminapi/experienceCard/publish",
               method: "POST",
               body: JSON.stringify({ ...params })
            }).then((res) => {
               if (res.body.error === 10000) {
                  this.queryList();
               } else {
                  this.$util.errorMsg(res.body.message || "请联系管理员");
               }
            }).catch((err) => {
               this.$util.errorMsg(err.message);
            }).finally(() => {
               this.loading = false;
            });
         }).catch(() => { });
      },
      // 发送删除
      sendDelete(params) {
         this.$confirm('确定要删除吗？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.loading = true;
            this.$http({
               url: this.$util.domain + "/adminapi/experienceCard/del",
               method: "POST",
               body: JSON.stringify({ ...params })
            }).then((res) => {
               if (res.body.error === 10000) {
                  this.queryList();
               } else {
                  this.$util.errorMsg(res.body.message || "请联系管理员");
               }
            }).catch((err) => {
               this.$util.errorMsg(err.message);
            }).finally(() => {
               this.loading = false;
            });
         }).catch(() => { });
      },
      // 点击重置
      clickReset() {
         this.paramData = {
            status: "",
            pageNum: 1,
            pageSize: 10,
         };
         this.queryList();
      },
      // 点击新增
      clickAddition() {
         this.$router.push({
            path: '/yunying/user/experience/card/detail',
            query: { actionType: 'add' }
         })
      },
      // 点击编辑
      clickEdit(row) {
         this.$util.setStore('experience-card-list-item', row);
         this.$router.push({
            path: '/yunying/user/experience/card/detail',
            query: { actionType: 'edit' }
         })
      },
      // 点击发布
      clickPublish(row) {
         const params = {
            id: row.id,
            status: 1,
         };
         this.updateStatus(params);
      },
      // 点击撤销
      clickRevoke(row) {
         const params = {
            id: row.id,
            status: 2,
         };
         this.updateStatus(params);
      },
      // 点击删除
      clickDelete(row) {
         const params = {
            id: row.id
         };
         this.sendDelete(params);
      },
      // 切换当前页码
      changeCurrentPage(value) {
         this.paramData.pageNum = value;
         this.queryList();
      },
      // 处理有效时间
      handleValidDate(row) {
         if (row.timeType == 2) {
            return '领取后' + row.effectTime + '天';
         }
         let startTime = '';
         if (row.startTime) {
            startTime = new Date(row.startTime).format("yyyy/MM/dd hh:mm:ss");
         }
         let endTime = '';
         if (row.endTime) {
            endTime = new Date(row.endTime).format("yyyy/MM/dd hh:mm:ss");
         }
         if (startTime && endTime) {
            return startTime + ' - ' + endTime;
         } else {
            return startTime || endTime || '';
         }
      },
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// ExperienceCard.vue?0ae87cbc